module.exports = "/assets/d4f7f362547e9e89dad8e0a7d31c0ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PX.png
// module id = 2856
// module chunks = 0